import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import DOEDashboard from "@/pages/DOEDashboard";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<DOEDashboard />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        position="bottom-right"
        toastOptions={{
          style: {
            fontFamily: "IBM Plex Sans, system-ui, sans-serif",
            borderRadius: "2px",
          },
        }}
      />
    </div>
  );
}

export default App;
